module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/woman@2x_d3c82a.png";